/** Ordered option ids — index 0 is rank 1 (most important). */
export type RankingAnswer = string[]

export function defaultRankingOrder(optionIds: readonly string[]): RankingAnswer {
  return [...optionIds]
}

/** Merge saved order with current options (handles added/removed options). */
export function resolveRankingOrder(
  value: RankingAnswer | null | undefined,
  optionIds: readonly string[],
): RankingAnswer {
  if (optionIds.length === 0) return []
  if (!value?.length) return defaultRankingOrder(optionIds)

  const valid = new Set(optionIds)
  const ordered: string[] = []
  for (const id of value) {
    if (valid.has(id) && !ordered.includes(id)) ordered.push(id)
  }
  for (const id of optionIds) {
    if (!ordered.includes(id)) ordered.push(id)
  }
  return ordered
}

export function isRankingAnswerComplete(
  value: RankingAnswer | null | undefined,
  optionCount: number,
): boolean {
  if (optionCount === 0) return false
  if (value?.length !== optionCount) return false
  return new Set(value).size === optionCount
}
